"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDefaultError = buildDefaultError;
exports.request = request;
exports.default = exports.RequestError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var defaultError = "Something behind the scenes isn't working as expected. Try again in a little bit.";
var forbiddenError = "You don't have permissions to perform this action.";
var notFoundError = "The resource you requested couldn't be found.";
var unauthorizedError = "It looks like you're not logged in anymore. Try logging in again.";

var RequestError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(RequestError, _Error);
  /**
   * Constructs a RequestError object.
   * @param {String} status The HTTP status code returned in the response.
   * @param {Object} body An arbitrary payload that can be attached to the error.
   * @param {String} message A human-readable error message.
   * @param {Array} params The rest of the arguments to pass down to the underlying Error object.
   */

  function RequestError(status, body, message) {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RequestError);

    for (var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      params[_key - 3] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RequestError)).call.apply(_getPrototypeOf2, [this, message].concat(params)));

    if (Error.captureStackTrace) {
      Error.captureStackTrace((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), RequestError);
    }

    _this.body = body;
    _this.status = status;
    return _this;
  }

  return RequestError;
}((0, _wrapNativeSuper2.default)(Error));
/**
 * Constructs a default error with no particularly useful information in it.
 * All this does it derive a reasonable error message from the status code.
 * @param {Number} status The HTTP status code returned by the response.
 * @returns {RequestError} A requset error with some default error text.
 */


exports.RequestError = RequestError;

function buildDefaultError(status) {
  if (status === 401) {
    return new RequestError(status, undefined, unauthorizedError);
  }

  if (status === 403) {
    return new RequestError(status, undefined, forbiddenError);
  }

  if (status === 404) {
    return new RequestError(status, undefined, notFoundError);
  }

  return new RequestError(status, undefined, defaultError);
}
/**
 * Performs a REST request against the specified URL.
 * @param {String} method The HTTP method to use for the request.
 * @param {String} url The endpoint to make the request to.
 * @param {Object} body The body of the request.
 * @param {String} token The JWT to use with the request.
 * @returns {Promise<Object>} A promise that resolves to the body and status code of the response.
 */


function request(_x, _x2, _x3, _x4) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(method, url, body, token) {
    var requestHeaders, requestBody, response, responseBody;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestHeaders = {
              Authorization: "Bearer ".concat(token),
              'Content-Type': body ? 'application/json' : undefined
            };
            requestBody = new Request(url, {
              body: body ? JSON.stringify(body) : undefined,
              headers: requestHeaders,
              method: method
            });
            _context.next = 4;
            return fetch(requestBody).catch(function () {
              return null;
            });

          case 4:
            response = _context.sent;

            if (!(!response || !response.json)) {
              _context.next = 7;
              break;
            }

            throw buildDefaultError();

          case 7:
            _context.next = 9;
            return response.json().catch(function () {
              return null;
            });

          case 9:
            responseBody = _context.sent;

            if (!(!responseBody && response.status >= 400)) {
              _context.next = 12;
              break;
            }

            throw buildDefaultError(response.status);

          case 12:
            return _context.abrupt("return", {
              body: responseBody,
              status: response.status
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _request.apply(this, arguments);
}

var _default = request;
exports.default = _default;